<button 
  mat-icon-button 
  [matMenuTriggerFor]="menu" 
  (click)="openActionMenu($event)" 
  aria-label="Actions"
  class="action-button">
  <mat-icon 
    [ngClass]="{ 'validated-icon': params.isValidated }"
    [matTooltip]="params.validationTooltip || ''"
    [matTooltipDisabled]="!params.isValidated"
    matTooltipPosition="above">
    {{ params.isValidated ? 'check_circle' : 'more_vert' }}
  </mat-icon>
</button>

<mat-menu #menu="matMenu" class="patient-action-menu">
  <button
    *ngIf="params.showInspect"
    mat-menu-item
    (click)="handleAction('inspect')"
    class="menu-item">
    <mat-icon>search</mat-icon>
    <span>Inspect</span>
  </button>
  <button
    *ngIf="params.showCreateTicket"
    mat-menu-item
    (click)="handleAction('createTicket')"
    class="menu-item">
    <mat-icon>create</mat-icon>
    <span>Create Ticket</span>
  </button>
  <button
    *ngIf="params.showValidate"
    mat-menu-item
    (click)="handleAction('validate')"
    class="menu-item">
    <mat-icon>{{ getValidationIcon() }}</mat-icon>
    <span>{{ getValidationMenuText() }}</span>
  </button>
</mat-menu>